import { create } from "zustand";

export type ThemeMode = "system" | "light" | "dark";

interface SettingsState {
    theme: ThemeMode;
    setTheme: (t: ThemeMode) => void;
}

export const useSettingsStore = create<SettingsState>((set) => ({
    theme:
        (typeof window !== "undefined" &&
            (localStorage.getItem("theme") as ThemeMode)) ||
        "system",
    setTheme: (t) => {
        localStorage.setItem("theme", t);
        set({ theme: t });
    },
}));
